import { useEffect, useRef } from 'react';

import { useLocation } from 'react-router-dom';

import { Box } from '@mui/material';

import { LessorSidebarFooter } from '~components/layout/sidebar/components/lessor-sidebar-footer';
import { Logo } from '~components/ui/logo/logo';

import { useMobileMenu } from '~hooks/use-mobile-menu';

import { lessorSidebarLinks } from './lessor-sidebar-routes';
import { SidebarMenu } from './menu/sidebar-menu';
import { SidebarWrapper } from './sidebar.styles';

export const LessorSidebar = () => {
  const { isMenuOpen, closeMenu } = useMobileMenu();

  const { pathname } = useLocation();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    if (prevPathname.current !== pathname) {
      closeMenu();
      prevPathname.current = pathname;
    }
  }, [pathname, closeMenu]);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  return (
    <>
      <SidebarWrapper isMenuOpen={isMenuOpen}>
        <Box
          sx={{
            width: '100%',
            display: { xs: 'none', md: 'flex' },
            justifyContent: 'center',
            mb: 5,
          }}
        >
          <Logo />
        </Box>
        <Box
          sx={{
            flex: 1,
            minHeight: 0, // критично для overflow в flex
            overflowY: 'auto',
            overflowX: 'hidden',
            WebkitOverflowScrolling: 'touch',
            pr: 0.5, // опционально: чтобы скроллбар не тер
            mb: 0.5,
          }}
        >
          <SidebarMenu links={lessorSidebarLinks} />
        </Box>

        <Box sx={{ flexShrink: 0 }}>
          <LessorSidebarFooter />
        </Box>
      </SidebarWrapper>

      <Box
        role={'button'}
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          zIndex: 9,
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          opacity: isMenuOpen ? 1 : 0,
          visibility: isMenuOpen ? 'visible' : 'hidden',
          pointerEvents: isMenuOpen ? 'auto' : 'none',
          transition: 'opacity 0.2s ease-in-out, visibility 0.2s ease-in-out',
        }}
        onClick={closeMenu}
      />
    </>
  );
};
